// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6GpW3","graphics":"styles_graphics__HT94X"};